import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ErrorMessageDisplay = props => {
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "invalid-feedback d-block mt-3", "data-testid": "ErrorMessage", id: props.id + '_errormessage' }, { children: [_jsx("span", { className: "icon icon-alert mb-1" }), props.message] })) }));
};
